(function (root) {
  'use strict';
  const ns = root.FKKInsurance = root.FKKInsurance || {};
  const targetSelector = '#main-cart-footer .cart__ctas, #CartDrawer .cart__ctas';
  const totalSelector = '.totals__total-value';

  function money(cents, currency) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2,
    }).format(cents / 100) + ' ' + currency;
  }

  class InsuranceView {
    constructor(document) {
      this.document = document;
    }

    mounts() {
      return Array.from(this.document.querySelectorAll(targetSelector));
    }

    create(target) {
      const element = this.document.createElement('div');
      element.className = 'tm-ship-insurance';
      element.dataset.fkkInsurance = '';
      element.innerHTML = '<div class="tm-insurance-header"><span class="tm-insurance-title"></span>' +
        '<div class="tm-insurance-control"><span class="tm-insurance-fee"></span>' +
        '<label class="tm-insurance-switch"><input type="checkbox" class="tm-insurance-checkbox">' +
        '<span class="tm-insurance-slider"></span></label></div></div>' +
        '<div class="tm-insurance-description"></div>' +
        '<p class="fkk-insurance-error" role="alert" hidden></p>' +
        '<button type="button" class="fkk-insurance-retry" hidden>Try again</button>';
      target.before(element);
      return element;
    }

    render(snapshot) {
      this.mounts().forEach((target) => {
        // The widget is a sibling of its CTA target, so check the parent, not target children.
        const parent = target.parentElement;
        const existing = Array.from(parent.children).filter((child) => child.hasAttribute('data-fkk-insurance'));
        const element = existing.shift() || this.create(target);
        existing.forEach((duplicate) => duplicate.remove());
        element.hidden = snapshot.ready && snapshot.count === 0;
        element.setAttribute('aria-busy', String(snapshot.busy));
        const title = snapshot.config?.title || 'Delivery Insurance';
        element.querySelector('.tm-insurance-title').textContent = title;
        const checkbox = element.querySelector('.tm-insurance-checkbox');
        checkbox.setAttribute('aria-label', title);
        checkbox.checked = snapshot.enabled;
        checkbox.disabled = !snapshot.ready || snapshot.busy || (!snapshot.enabled && snapshot.fee === null);
        element.querySelector('.tm-insurance-slider').classList.toggle('checked', snapshot.enabled);
        element.querySelector('.tm-insurance-fee').textContent = snapshot.fee === null ? '' : money(snapshot.fee, snapshot.currency);
        element.querySelector('.tm-insurance-description').textContent = snapshot.enabled
          ? snapshot.config?.description || '' : 'Delivery insurance is not included.';
        let error = snapshot.error ? 'We couldn’t update delivery insurance. Please try again before checking out.' : '';
        if (!error && snapshot.ready && snapshot.enabled && snapshot.fee === null) {
          error = 'Delivery insurance is unavailable in this currency. Turn it off to continue.';
        }
        const errorElement = element.querySelector('.fkk-insurance-error');
        errorElement.hidden = !error;
        errorElement.textContent = error;
        element.querySelector('.fkk-insurance-retry').hidden = !snapshot.error || snapshot.busy;
      });
      if (snapshot.ready && snapshot.total !== null) {
        this.document.querySelectorAll(totalSelector).forEach((element) => {
          const text = money(snapshot.total, snapshot.currency);
          if (element.textContent !== text) element.textContent = text;
        });
      }
    }

    observe(callback) {
      const observer = new root.MutationObserver((mutations) => {
        const changed = mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => (
          node.nodeType === 1 && !node.closest('[data-fkk-insurance]') &&
          (node.matches(targetSelector + ', ' + totalSelector) || node.querySelector(targetSelector + ', ' + totalSelector))
        )));
        if (changed) callback();
      });
      observer.observe(this.document.body, { childList: true, subtree: true });
      return observer;
    }
  }

  Object.assign(ns, { InsuranceView, insuranceMoney: money });
  if (typeof module !== 'undefined') module.exports = ns;
})(globalThis);
